export const wysiwygField = {
  subject: "subject",
  message: "message",
  to: "to",
  cc: "cc",
  bcc: "bcc",
};
